import React from "react";
import { Switch, Route } from "react-router-dom";
//routes
import AuthenticatedRoute from "./AuthenticatedRoute";
import RedirectRoute from "./RedirectRoute";

//components
import Profile from "../pages/Profile";
import Purchase from "../pages/Purchase";
import PurchaseConfirmation from "../pages/PurchaseConfirmation";
import PayPalReturn from "../pages/PayPalReturn";
import PaymentSuccess from "../pages/PaymentSuccess";
import PaymentFailed from "../pages/PaymentFailed";
import TokenLogin from "../pages/TokenLogin";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import NotFoundPage from "../pages/NotFoundPage";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <Switch>
      <Route 
        exact 
        path="/pilot/purchase/payment-callback" 
        component={PayPalReturn}
      />
      <Route
        exact
        path="/"
        render={(props) => {
          // Check if this is a PayPal return with token
          const params = new URLSearchParams(props.location.search);
          const token = params.get('token');
          if (token) {
            return <PayPalReturn {...props} />;
          }
          // Otherwise redirect to profile
          return <RedirectRoute exact path="/" redirectPath="/pilot/profile" />;
        }}
      />
      <RedirectRoute exact path="/pilot" redirectPath="/pilot/profile" />
      <Route exact path="/pilot/auth/token" component={TokenLogin} />
      <Route exact path="/pilot/login" component={Login} />
      <Route exact path="/pilot/forgot-password" component={ForgotPassword} />
      <Route
        exact
        path="/pilot/forgot-password/reset-password/:token"
        component={ResetPassword}
      />
      <AuthenticatedRoute exact path="/pilot/profile" component={Profile} />
      <AuthenticatedRoute
        exact
        path="/pilot/profile/confirm-email/:token"
        component={Profile}
      />
      <AuthenticatedRoute exact path="/pilot/purchase" component={Purchase} />
      <AuthenticatedRoute
        exact
        path="/pilot/purchase/confirm"
        component={PurchaseConfirmation}
      />
      <AuthenticatedRoute
        exact
        path="/pilot/payment/success"
        component={PaymentSuccess}
      />
      <AuthenticatedRoute
        exact
        path="/pilot/payment/failed"
        component={PaymentFailed}
      />
      <Route path="*" exact component={NotFoundPage} />
    </Switch>
  );
};
